import styles from './voucher-gift.module.scss'
import React, { useEffect, useState, useRef } from 'react'
import { compare, formatCash } from 'utils'

import { Input, Row, Col, Table, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

//components
import TitlePage from 'components/title-page'
import FilterDate from 'components/filter-date'
import VoucherGiftForm from './voucher-gift-form'

//apis
import { getVouchers } from 'apis/voucher'

export default function VoucherGift() {
  const typingTimeoutRef = useRef(null)

  const [countVoucher, setCountVoucher] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [vouchers, setVouchers] = useState([])
  const [loading, setLoading] = useState(false)
  const [valueSearch, setValueSearch] = useState('')

  const columnsVoucher = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
      width: 80,
    },
    {
      title: 'Mã voucher',
      sorter: (a, b) => compare(a, b, 'code'),
      dataIndex: 'code',
    },
    {
      title: 'Giá trị khởi tạo',
      sorter: (a, b) => compare(a, b, 'final_cost'),
      render: (data, record) => <div>{formatCash(record.final_cost || 0)}</div>,
    },
    {
      title: 'Giá trị hiện tại',
      sorter: (a, b) => compare(a, b, 'value_current'),
      render: (data, record) => <div>{formatCash(record.value_current || 0)}</div>,
    },
    {
      title: 'Loại',
      render: (data, record) => <div>{record.type == 'value' ? 'Giá trị' : 'Phần trăm'}</div>,
    },
    {
      title: 'Áp dụng tối đa',
      sorter: (a, b) => compare(a, b, 'limit_apply'),
      render: (data, record) => <div>{formatCash(record.limit_apply || 0)}</div>,
    },
    {
      title: 'Đơn hàng tối thiểu',
      sorter: (a, b) => compare(a, b, 'minium_apply'),
      render: (data, record) => <div>{formatCash(record.minium_apply || 0)}</div>,
    },
    {
      title: 'Tiền tệ',
      render: (data, record) => <div>{record.currency || ''}</div>,
    },
    {
      title: 'Hết han',
      sorter: (a, b) => compare(a, b, 'date_expire'),
      render: (data, record) => <div>{record.date_expire || ''}</div>,
    },
    {
      title: 'Liên hệ',
      dataIndex: 'phone',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Người tạo',
      render: (data, record) => record.creator_info && record.creator_info.full_name,
    },
  ]

  const onSearch = (e) => {
    setValueSearch(e.target.value)

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.code = value
      else delete paramsFilter.code
      setParamsFilter({ ...paramsFilter, page: 1 })
    }, 750)
  }

  const onFilters = (attribute = '', value = '') => {
    if (value) paramsFilter[attribute] = value
    else delete paramsFilter[attribute]
    setParamsFilter({ ...paramsFilter })
  }

  const _getVouchers = async () => {
    try {
      setLoading(true)
      const res = await getVouchers({ ...paramsFilter, _creator: true, is_gift: true })
      console.log(res)
      if (res.status === 200) {
        setVouchers(res.data.data)
        setCountVoucher(res.data.count)
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    _getVouchers()
  }, [paramsFilter])

  return (
    <>
      <div className={`${styles['voucher_manager']} ${styles['card']}`}>
        <TitlePage title="QUẢN LÝ VOUCHER TẶNG">
          <VoucherGiftForm reload={() => _getVouchers()}>
            <Button size="large" type="primary">
              Tạo voucher tặng
            </Button>
          </VoucherGiftForm>
        </TitlePage>

        <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <Input
              prefix={<SearchOutlined />}
              size="large"
              placeholder="Tìm kiếm voucher"
              onChange={onSearch}
              allowClear
              value={valueSearch}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <FilterDate
              size="large"
              paramsFilter={paramsFilter}
              setParamsFilter={setParamsFilter}
            />
          </Col>
        </Row>
        <br />
        <div>
          <Table
            size="small"
            rowKey="voucher_id"
            loading={loading}
            pagination={{
              position: ['bottomLeft'],
              current: paramsFilter.page,
              defaultPageSize: 20,
              pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
              showQuickJumper: true,
              onChange: (page, pageSize) =>
                setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
              total: countVoucher,
            }}
            columns={columnsVoucher}
            dataSource={vouchers}
            scroll={{ y: 500 }}
            summary={(total) => (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  <Table.Summary.Cell>
                    <b>Tổng</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>
                    {formatCash(total.reduce((total, current) => total + current.final_cost, 0))}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            )}
          />
        </div>
      </div>
    </>
  )
}
